import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { handleGetUserFromLocalStorage } from "../../../utils/common";

const ProtectedRoutes: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const currentUser = handleGetUserFromLocalStorage();
  if (currentUser === null) {
    return <Navigate to={"/"} />;
  } else {
    return <>{children}</>;
  }
};

export default ProtectedRoutes;
